/**
 * Send user profile form to server
 */
export default function updateUserProfile() {
    spinner.show();
    let form = $('#form_user_profile');
    form.find('.form-group').removeClass('has-error').removeClass('has-success');
    form.find('.help-block-error').remove();
    form.find('[aria-invalid]').removeAttr('aria-invalid');

    let formData = new FormData(form[0]);
    $.ajax({
        url: '/site/users/update-details',
        data: formData,
        processData: false,
        contentType: false,
        type: 'post',
        dataType: 'json'
    }).done(function (data) {
        spinner.remove();
        if (data.success) {
            openAlert(data.message, 'success', 2000).finally(() => {
                window.location.reload()
            });
        } else {
            Object.entries(data.errors).forEach(function ([field, message]) {
                const $field = form.find('#' + field)
                let group = $field.closest('.form-group')
                group.addClass('has-error').append($('<p>').attr('id',field+'-error').addClass('help-block').addClass('help-block-error').html(message));
                $field.attr('aria-invalid', 'true');
                $field.attr('aria-describedby', field+'-error');
                //
                // phone cc:
                const phoneCC = form.find('#' + field + '_cc');
                if(phoneCC.length) {
                    phoneCC.attr('aria-invalid', 'true')
                    phoneCC.attr('aria-describedby',field+'-error');
                }
                // wysiwyg:
                const contentEditor = form.find('#' + field + '_trumbowyg-editor');
                if(contentEditor.length) {
                    contentEditor.attr('aria-invalid', 'true')
                    contentEditor.attr('aria-describedby',field+'-error');
                }
            });
            if (data.message) {
                openAlert(data.message, 'error', 2000);
            }
            form.find('.has-error :visible:focusable:first').focus()
        }
    }).fail(function () {
        spinner.remove();
        window.openAlert(getCommonError(), 'error');
    });
}
